import { useFormContext } from "react-hook-form";
import useSnackbar from "src/store/useSnackbar";
export const useCheckoutForm = (onValidSubmit)=>{
    const { handleSubmit , watch , setError , formState: { errors  }  } = useFormContext();
    const { addSnackbar  } = useSnackbar();
    const onValidFormSubmit = (data)=>{
        // 주문자 정보가 없으면 제출하지 않음
        if (!data.buyerName || !data.buyerPhone) {
            if (!data.buyerName) {
                setError("buyerName", {
                    type: "required",
                    message: "주문자 이름을 입력해주세요."
                });
            }
            if (!data.buyerPhone) {
                setError("buyerPhone", {
                    type: "required",
                    message: "주문자 전화번호를 입력해주세요."
                });
            }
            // 이미 유효한 값이 있으므로 필수값 누락 시 에러 처리
            // 이미 onValidFormSubmit으로 넘어왔기 때문에 한번더 onInvalidFormSubmit 호출
            onInvalidFormSubmit({
                buyerName: !data.buyerName ? {
                    type: "required",
                    message: "주문자 이름을 입력해주세요."
                } : undefined,
                buyerPhone: !data.buyerPhone ? {
                    type: "required",
                    message: "주문자 전화번호를 입력해주세요."
                } : undefined
            });
            return;
        }
        // 배송지 정보가 없으면 제출하지 않음
        if (!data.address1 || !data.address2) {
            setError("address1", {
                type: "required",
                message: "배송지를 입력해주세요."
            });
            return;
        }
        onValidSubmit(data);
    };
    const onInvalidFormSubmit = (errors)=>{
        const hasRequiredError = Object.values(errors).some((error)=>{
            if ((error === null || error === void 0 ? void 0 : error.type) === "required") return true;
            return false;
        });
        if (hasRequiredError) {
            addSnackbar({
                message: "필수 항목을 입력해주세요.",
                variant: "error"
            });
        }
    };
    return {
        handleSubmit,
        onValidFormSubmit,
        onInvalidFormSubmit
    };
};
